export const DELETE_EVENT = 'DELETE_EVENT'; // delete event
export const DELETE_EVENT_ERROR = 'DELETE_EVENT_ERROR';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';

export const GET_EVENT = 'GET_EVENT'; // get single event
export const GET_EVENT_ERROR = 'GET_EVENT_ERROR';
export const GET_EVENT_SUCCESS = 'GET_EVENT_SUCCESS';

export const SAVE_EVENT = 'SAVE_EVENT'; // update event or create event
export const SAVE_EVENT_ERROR = 'SAVE_EVENT_ERROR';
export const SAVE_EVENT_SUCCESS = 'SAVE_EVENT_SUCCESS';

export const GET_ALL_EVENT = 'GET_ALL_EVENT'; // get all event
export const GET_ALL_EVENT_ERROR = 'GET_ALL_EVENT_ERROR';
export const GET_ALL_EVENT_SUCCESS = 'GET_ALL_EVENT_SUCCESS';

export const CLEAR_EVENT = 'CLEAR_EVENT';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Information/Calendar/constants.js